import { createContext, useContext } from 'react';
import { IChatMessages } from '@enuan/chat__utils';
import { IClientMessage } from '../../interfaces/IClientMessage';

export type IMessageContextState<
	M extends IChatMessages | never = IChatMessages,
> = {
	message: M extends never ? undefined : IClientMessage<M>;
	isFirstMessage?: boolean;
	isLastMessage?: boolean;
	isFirstBlock?: boolean;
	isLastBlock?: boolean;
	isDifferentDayBlock?: boolean;
};

export const messageContext = createContext<IMessageContextState>(
	{} as IMessageContextState,
);

export const useMessageContext = <T extends IChatMessages | never = never>() =>
	useContext(messageContext) as unknown as IMessageContextState<T>;
